module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-in-down-4620abbd.svg";